import React, { useEffect, useState } from "react";
import style from "css/solution.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import { Pagination } from "swiper/modules";
import Questions from "components/app/questions";
import SEOMeta from "components/app/SEOMeta";

function PrivateConnectManager() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [controlledSwiper, setControlledSwiper] = useState(null);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <SEOMeta
        title="Private Connect Manager, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - Private Connect Manager"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, 스마트 회의실, 화상회의, Private Connect Manager"
      />
      <section className={style.wrapper}>
        <section
          className={`${style.container} ${style.private_connect_manager_content}`}
        >
          <section className={style.banner_section}>
            <article className={style.banner_article}>
              <div className={style.banner_title}>
                <p>Private Connect 운용을 위한 최적의 관리 솔루션,</p>
                <p>Private Connect Manager</p>
                {isMobile ? (
                  <>
                    <p>Private Connect Manager는</p>
                    <p>Private Connect의 운용 및 관리를 위한</p>
                    <p>관리자 전용 시스템입니다.</p>
                  </>
                ) : (
                  <>
                    <p>
                      Private Connect Manager는 Private Connect의 운용 및 관리를
                      위한
                    </p>
                    <p>관리자 전용 시스템입니다.</p>
                  </>
                )}
              </div>
              <div className={style.banner_company}>
                <p>Trusted by many companies</p>
                <div className={style.banner_company_ci}>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/ci_daejeon.png`}
                    alt="대전광역시"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/ci_khnp.png`}
                    alt="한국수력원자력"
                  />
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/ci_gb_119.png`}
                    alt="경상북도소방본부"
                  />
                </div>
              </div>
            </article>
            <img
              src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/banner.png`}
              alt="banner"
            />
          </section>
          <section className={style.description_section}>
            <article className={style.description_article}>
              <p>
                <font>Private Connect 기반</font>
              </p>
              <p>강력한 영상회의 서비스 관리 솔루션</p>
            </article>

            <article className={style.description_sub_article}>
              {isMobile ? (
                <>
                  <p>Private Connect Manager만의</p>
                  <p>장점을 살린 다양한 기능들을 통해</p>
                  <p>영상회의 서비스를 제공하며</p>
                  <p>관리자의 안정성과 편의성을 보장합니다.</p>
                </>
              ) : (
                <>
                  <p>
                    Private Connect Manager만의 장점을 살린 다양한 기능들을 통해
                  </p>
                  <p>
                    영상회의 서비스를 제공하며 관리자의 안정성과 편의성을
                    보장합니다.{" "}
                  </p>
                </>
              )}
            </article>

            <p className={style.description_comment}>관리자 계정만 제공</p>
            <section className={style.description_item_section}>
              <div className={style.description_item_list}>
                <div className={style.description_item}>
                  <article className={style.description_item_article}>
                    <p>
                      실시간 회의 제어<font>Active Meeting</font>
                    </p>
                    <p>
                      실시간 회의 연동을 통한 효율적이고 편리한 회의 제어 및
                      관리
                    </p>
                  </article>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/desc_active_meeting.png`}
                    alt="Active Meeting"
                  />
                  <article className={style.description_item_article}>
                    <p>영상회의 제어</p>
                    <p>
                      영상회의 단말 연결/해제 · 음소거/비디오 · Mute · 녹화 ·
                      템플릿 변경 · 영상회의 단말 추가 연결 등의 기능 제공
                    </p>
                  </article>
                </div>
                <div className={style.description_item}>
                  <article className={style.description_item_article}>
                    <p>CDR Provide</p>
                    <p>
                      실시간 회의 연동을 통한 효율적이고 편리한 회의 제어 및
                      관리
                    </p>
                  </article>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/desc_cdr_provider.png`}
                    alt="Active Meeting"
                  />
                  <article className={style.description_item_article}>
                    <p>통계</p>
                    <p>
                      회의 시작/종료 시간 · 총 사용시간 · 초 단위 · Call ID ·
                      Co-Space · 참석자 수 관련 정보 제공
                    </p>
                  </article>
                </div>
              </div>
              <div className={style.description_item_list}>
                <div className={style.description_item}>
                  <article className={style.description_item_article}>
                    <p>Private Connect Management</p>
                    <p>
                      실시간 회의 연동을 통한 효율적이고 편리한 회의 제어 및
                      관리
                    </p>
                  </article>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/desc_private_connect_management.png`}
                    alt="Active Meeting"
                  />
                  <article className={style.description_item_article}>
                    <p>Private Connect 관리</p>
                    <p>
                      Private Connect 상태 관리 및 제어, 단말, 사용자 등록,
                      회의실 개설, 미팅 스케줄 관리 등의 기능 제공
                    </p>
                  </article>
                </div>
              </div>
            </section>
          </section>
          <section className={style.features_section}>
            <p className={style.features_title}>
              Private Connect Manager 특장점
            </p>
            <div className={style.features_btn_container}>
              <button
                className={
                  activeIdx === 0
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(0)}
              >
                1. 시스템 상태 정보
              </button>
              <button
                className={
                  activeIdx === 1
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(1)}
              >
                2. 주소록 및 그룹관리
              </button>
              <button
                className={
                  activeIdx === 2
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(2)}
              >
                3. 레이아웃
              </button>
              <button
                className={
                  activeIdx === 3
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(3)}
              >
                4. 회의실 관리
              </button>
              <button
                className={
                  activeIdx === 4
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(4)}
              >
                5. 실시간 회의 제어
              </button>
              <button
                className={
                  activeIdx === 5
                    ? `${style.features_btn} ${style.active}`
                    : style.features_btn
                }
                onClick={() => controlledSwiper.slideTo(5)}
              >
                6. 통계
              </button>
            </div>
            <div className={style.features_swiper_container}>
              <Swiper
                className={style.features_swiper}
                spaceBetween={80}
                grabCursor={true}
                pagination={{
                  dynamicBullets: false,
                }}
                modules={[Pagination]}
                onSwiper={setControlledSwiper}
                onSlideChange={(swiper) => {
                  setActiveIdx(swiper.activeIndex);
                }}
              >
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        시스템 관리
                      </p>
                      <div className={style.features_swiper_item_title_txt}>
                        <p>시스템 상태정보 및</p>
                        <p>라이선스 현황</p>
                      </div>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        {isMobile ? (
                          <>
                            <p>시스템의 상태정보와</p>
                            <p>라이선스 현황을 모니터링하고</p>
                            <p>관리할 수 있습니다.</p>
                          </>
                        ) : (
                          <>
                            <p>시스템의 상태정보와</p>
                            <p>
                              라이선스 현황을 모니터링하고 관리할 수 있습니다.
                            </p>
                          </>
                        )}
                      </div>
                      <div>
                        <p>필요에 따라 서버를 재부팅하거나</p>
                        <p>수정할 수 있는 기능을 제공합니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/feature_system.png`}
                    alt="시스템 상태정보 및 라이선스 현황"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        그룹관리
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>등록된 주소록의</p>
                        <p>그룹관리</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>등록된 주소록의 그룹을 관리하고,</p>
                        <p>단말 장비를 그룹별로 지정하여</p>
                        <p>체계적으로 운영할 수 있습니다.</p>
                      </div>
                      <div>
                        <p>그룹 추가, 수정, 삭제 기능을 통해</p>
                        <p>단말을 효율적으로 관리할 수 있습니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/feature_group.png`}
                    alt="그룹관리"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        레이아웃 배치 및 템플릿
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>진행 중인 영상회의</p>
                        <p>레이아웃 변경 및 단말 배치</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        {isMobile ? (
                          <>
                            <p>진행 중인 영상회의 레이아웃을 변경하고,</p>
                            <p>단말을 드래그 앤 드롭 방식으로</p>
                            <p>배치할 수 있습니다.</p>
                            <p>이 레이아웃을 템플릿으로 저장하여,</p>
                            <p>이후 회의에서 쉽게 적용할 수 있습니다.</p>
                          </>
                        ) : (
                          <>
                            <p>진행 중인 영상회의 레이아웃을 변경하고,</p>
                            <p>
                              단말을 드래그 앤 드롭 방식으로 배치할 수 있습니다.
                            </p>
                            <p>이 레이아웃을 템플릿으로 저장하여,</p>
                            <p>이후 회의에서 쉽게 적용할 수 있습니다.</p>
                          </>
                        )}
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/feature_layout.png`}
                    alt="레이아웃 배치 및 템플릿"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        회의실 관리
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>영상회의 상세 내용과</p>
                        <p>회의 제어 및 단말 초대</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        <p>영상회의의 상세 정보를 관리하고,</p>
                        <p>회의 제어 및 단말 초대 기능을 제공합니다.</p>
                      </div>
                      <div>
                        {isMobile ? (
                          <>
                            <p>새로운 회의실을 추가하거나</p>
                            <p>기존 회의실을 삭제할 수 있으며,</p>
                            <p>필요한 단말을 회의에 초대할 수 있습니다.</p>
                          </>
                        ) : (
                          <>
                            <p>
                              새로운 회의실을 추가하거나 기존 회의실을 삭제할 수
                              있으며,
                            </p>
                            <p>필요한 단말을 회의에 초대할 수 있습니다.</p>
                          </>
                        )}
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/feature_cospace.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        Active Meeting
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>진행중인 영상회의</p>
                        <p>실시간 제어 기능</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      <div>
                        {isMobile ? (
                          <>
                            <p>진행 중인 영상회의를</p>
                            <p>실시간으로 제어할 수 있는 기능을 제공합니다.</p>
                          </>
                        ) : (
                          <p>
                            진행 중인 영상회의를 실시간으로 제어할 수 있는
                            기능을 제공합니다.
                          </p>
                        )}
                      </div>
                      <div>
                        <p>음소거, 비디오 Mute, 접속 단말 리스트 관리,</p>
                        <p>단말 레이아웃 변경 등 다양한 제어 기능을 통해</p>
                        <p>회의의 원활한 진행을 지원합니다.</p>
                      </div>
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/feature_active_meeting.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
                <SwiperSlide className={style.features_swiper_item}>
                  <div className={style.features_swiper_item_article}>
                    <article className={style.features_swiper_item_title}>
                      <p className={style.features_swiper_item_title_id}>
                        통계
                      </p>
                      <article className={style.features_swiper_item_title_txt}>
                        <p>영상회의 Call 정보에 대한</p>
                        <p>CDR 기반 통계</p>
                      </article>
                    </article>
                    <article className={style.features_swiper_item_description}>
                      {isMobile ? (
                        <div>
                          <p>영상회의의 Call 정보를</p>
                          <p>CDR(Call Detail Record) 기반으로</p>
                          <p>통계화하여 제공합니다.</p>
                        </div>
                      ) : (
                        <div>
                          <p>영상회의의 Call 정보를 CDR (Call Detail Record)</p>
                          <p>기반으로 통계화하여 제공합니다.</p>
                          <p>
                            회의의 시작/종료 시간, 사용 시간, 참석자 정보 등을
                            조회하고,
                          </p>
                          <p>통계 데이터를 엑셀로 다운로드할 수 있습니다.</p>
                        </div>
                      )}
                      {isMobile ? (
                        <div>
                          <p>회의의 시작/종료 시간, 사용 시간,</p>
                          <p>참석자 정보 등을 조회하고,</p>
                          <p>통계 데이터를 엑셀로 다운로드할 수 있습니다.</p>
                        </div>
                      ) : (
                        <></>
                      )}
                    </article>
                  </div>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/feature_cdr.png`}
                    alt="Active Meeting"
                  />
                </SwiperSlide>
              </Swiper>
            </div>
          </section>
          <section className={style.partner_section}>
            <p className={style.partner_title}>Our Clients and Partners</p>
            <article className={style.partner_description}>
              {isMobile ? (
                <>
                  <p>Private Connect Manager는</p>
                  <p>다양한 산업 분야에서 신뢰받는</p>
                  <p>파트너로 자리매김하며,</p>
                  <p>각종 기관과 기업의 영상회의를 안정적이고</p>
                  <p>효율적으로 운영할 수 있도록 지원하고 있습니다.</p>
                  <p>우리의 고객들은 Private Connect Manager를</p>
                  <p>통해 회의와 장비를 통합 관리하며,</p>
                  <p>업무 효율성과 협업 능력을 극대화하고 있습니다.</p>
                </>
              ) : (
                <>
                  <p>
                    Private Connect Manager는 다양한 산업 분야에서 신뢰받는
                    파트너로 자리매김하며,
                  </p>
                  <p>
                    각종 기관과 기업의 영상회의를 안정적이고 효율적으로 운영할
                    수 있도록 지원하고 있습니다.
                  </p>
                  <p>
                    우리의 고객들은 Private Connect Manager를 통해 회의와 장비를
                    통합 관리하며, 업무 효율성과 협업 능력을 극대화하고
                    있습니다.
                  </p>
                </>
              )}
            </article>
            <div className={style.partner_list}>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/ci_daejeon.png`}
                  alt="대전광역시"
                />
                <p className={style.partner_item_title}>대전광역시</p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/ci_khnp.png`}
                  alt="한국수력원자력 월성원자력"
                />
                <p className={style.partner_item_title}>
                  한국수력원자력 월성원자력
                </p>
              </div>
              <div className={style.partner_item}>
                <img
                  src={`${process.env.REACT_APP_CLIENT_URL}img/solution/privateConnectManager/ci_gb_119.png`}
                  alt="경상북도 소방본부"
                />
                <p className={style.partner_item_title}>경상북도 소방본부</p>
              </div>
            </div>
          </section>
          <section
            className={style.promotion_section}
            style={{
              backgroundImage:
                "url('" +
                process.env.REACT_APP_CLIENT_URL +
                "img/solution/privateConnectManager/promotion_bg.png')",
            }}
          >
            <div
              className={style.promotion_item}
              style={{
                backgroundImage:
                  "url('" +
                  process.env.REACT_APP_CLIENT_URL +
                  "img/solution/privateConnectManager/promotion_plan_card.png')",
              }}
            >
              <p className={style.promotion_title}>
                <strong>
                  효율적인 운영과{isMobile ? <br /> : " "}직관적인 제어
                </strong>
                를{isMobile ? <br /> : " "}위한 통합 관리 시스템!
              </p>
              <article className={style.promotion_description}>
                <p>복잡한 회의실을 운영을 간단하게,</p>
                <p>
                  Private Connect Manager 하나로 스마트하고 안정정인 장비 제어
                  환경을 구축할 수 있습니다.
                </p>
              </article>
            </div>
          </section>
          <Questions />
        </section>
      </section>
    </>
  );
}

export default PrivateConnectManager;
